import axios from "axios";
import constants from "config/constants";

const { API_BASE_URL } = constants;
const BASE_URL = `${API_BASE_URL}/playgrounds`;

export default {
  getMySignedId: () => axios.get(`${BASE_URL}/my-id/`),
  getProducts: () =>
    axios.get(`${BASE_URL}/products/`, { params: { limit: 200 } }),
  getProduct: productId => axios.get(`${BASE_URL}/products/${productId}/`),
  getMyProfile: () => axios.get(`${BASE_URL}/info-play-id/`),
  getMissions: () => axios.get(`${BASE_URL}/missions/`),
  getInOut: (offset = 0, limit = 100) =>
    axios.get(`${BASE_URL}/in-out/`, { params: { offset, limit } }),
  postClaimBonus: () => axios.post(`${BASE_URL}/claim-bonus/`),
  getStandings: () => axios.get(`${BASE_URL}/standings`),
};
